/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OverrideOutAction } from './overrideOutAction';
import type { OverrideOutScope } from './overrideOutScope';

export interface OverrideOut {
  action: OverrideOutAction;
  scope: OverrideOutScope;
}
